 'use client';

 import { useI18n } from '@/shared/providers/I18nProvider';

type ChatErrorAlertProps = {
  error: Error | undefined;
};

export function ChatErrorAlert({ error }: ChatErrorAlertProps) {
  const { dict } = useI18n();
  if (!error) return null;

  return (
    <div className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800">
      {dict.common.errors.generic}{' '}
      <span className="text-red-600">
        ({String(error.message ?? error)})
      </span>
    </div>
  );
}
